<template>
  <span v-if="form.form_description">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
            v-bind="attrs"
            v-on="on"
            @click.stop
            dense
            aria-label="Template omschrijving"
        >
          mdi-help-circle-outline
        </v-icon>
      </template>
      <div @click.stop style="white-space: pre-wrap; max-width: 320px;">{{ form.form_description }}</div>
    </v-tooltip>
  </span>
</template>
<script>
export default {
  name: 'FormDescriptionTooltip',
  props: {
    form: Object,
  },
}
</script>
<style lang="scss" scoped>

</style>
